import MojitoCore from 'mojito/core';
import HomePageClassic from './classic/index.js';
import HomePageAvantgarde from './avantgarde/index.js';

const UIViewFamily = MojitoCore.Presentation.UIViewFamily;

/**
 * @namespace HomePage
 * @memberof Mojito.Applications.Sports.Pages
 */

/**
 * The home page.
 *
 * @class HomePage
 * @memberof Mojito.Applications.Sports.Pages.HomePage
 */

export default UIViewFamily('HomePage', {
    classic: HomePageClassic,
    avantgarde: HomePageAvantgarde,
});
